





export default {
  name: 'SidebarGroupContent',
};
